export default __webpack_public_path__ + "static/media/personal_website.7c144844.png";